<template>
  <div>
    <div class="ed-input">
      <input
        type="text"
        name=""
        id=""
        class="ed-input__field"
        :placeholder="placeholder" v-model="words"/>
      <box-icon name="x" class="ed-input__icon" @click="clearField"/>
    </div>
  </div>
</template>

<script>
import clickOutside from '../../directives/click-outside';

export default {
  name: 'ed-input',
  props: ['onChange', 'placeholder', 'value'],
  directives: {
    clickOutside,
  },
  data() {
    return {
      words: this.value || '',
    };
  },
  watch: {
    words(val) {
      console.log(val);
      this.words = val;
      this.onChange(val);
    },
  },
  methods: {
    clearField() {
      this.words = '';
      this.onChange('');
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
